<template>
  <loader-line v-if="isGlobalLoading"/>
  <alert :text-alert="activeAlert.text"
         :type="activeAlert.type"
         :active-alert="activeAlert.state"/>
  <modal-layout @closeModal="closeModal"/>
  <router-view/>
</template>

<script>
import {mapActions, mapState} from "vuex";
import LoaderLine from "@/components/shared/loader/LoaderLine.vue";
import Alert from "@/components/shared/Alert.vue";
import ModalLayout from "@/components/entities/modals/layout/ModalLayout.vue";

export default {
  name: "MainLayout",
  components: {ModalLayout, Alert, LoaderLine},
  computed: {
    ...mapState(['activeAlert', 'isGlobalLoading']),
  },
  mounted() {
    this.checkSize();
    addEventListener('resize', this.checkSize)
  },
  unmounted() {
    removeEventListener('resize', this.checkSize)
  },
  methods: {
    ...mapActions(['MODAL', 'IS_MOBILE']),
    closeModal() {
      this.MODAL(null)
    },
    checkSize() {
      this.innerHeight = window.innerHeight;
      document.documentElement.style.setProperty('--vh', `${this.innerHeight * 0.01}px`);
      this.innerWidth = window.innerWidth;
      document.documentElement.style.setProperty('--vw', `${this.innerWidth * 0.01}px`);
      this.IS_MOBILE(this.innerWidth < 769)
    }
  }
}
</script>

<style scoped>

</style>